/**
 * Copyright (c) Qwoach LLC 2023. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.05.23
 *
 */
import BaseObject from "@shared/BaseObject.js";
import IntegrationStatus from "@shared/Billing/IntegrationStatus";

export default class EmailIntegrationStatus extends BaseObject {

	email: string = null
	domain: string = null
	status: IntegrationStatus = null


	constructor() {
		super();
	}

	getStatus(){
		return this.status || IntegrationStatus.NOT_SET
	}

	isIntegrated(){
		return this.status === IntegrationStatus.INTEGRATED
	}

	isPending(){
		return this.status === IntegrationStatus.PENDING
	}

	setIntegration(status, email, domain){
		this.status = status
		if(email){
			this.email = email
		}
		if(domain){
			this.domain = domain
		}
	}
}
